import React, { Component } from "react";
import { dataUsuario } from "../../redux/actions/aLogin";
import { limpiarDisclaimer } from "../../redux/actions/aRamos";
import { connect } from "react-redux";
import "../../styles/estilos.css";
import "../../components/Login/login.css";
import { withRouter } from "react-router-dom";
import{dataUsuarioVacio} from "../../constants"

class ContainerLogout extends Component {
  constructor(props) {
    super(props);
    
   
  }


  componentDidMount = () => {    
    localStorage.setItem("login", false);
    this.props.limpiarDisclaimer();
    this.props.setDataUsuario(dataUsuarioVacio);
    this.props.history.push({
      pathname: `/login`
    });     
  };

  render() {      
    return (
      <div>REDIRECCIONANDO</div>
    );
  }
}
  


const mapStateToProps = state => ({
  userIsLoggedIn: state.datosUsuarios.dataUsuario.userIsLoggedIn,
  
});

const mapDispatchToProps = dispatch => {
  return {
    setDataUsuario: data => dispatch(dataUsuario(data)),
    limpiarDisclaimer: () => dispatch(limpiarDisclaimer())
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ContainerLogout)
);
